import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App.tsx";
import "./styles/index.scss";

import { CartProvider } from "./context/CartContext.tsx"; // 🛒 логіка кошика
import { CartModalProvider } from "./context/CartModalContext"; // 📦 модалка кошика

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <CartProvider>
        <CartModalProvider>
          <App />
        </CartModalProvider>
      </CartProvider>
    </BrowserRouter>
  </StrictMode>
);
